import modalMixin from '../../mixins/_modal';
import showStaticHtml from '../../components/_show_static_html';

/**
 * build_storeプレビュー
 */
export default {
    name: 'preview',
    template: '#preview',
    data() {
        return {
            // モーダル表示用
            modal_template: {},
        };
    },
    props: {
        // 表示モード modal|inline
        mode: {
            type: [String],
            require: true
        },
        // インライン表示したい場合はpropsで渡す
        inline_template: {
            type: [Object],
            default: () => ({}),
            require: false
        },
    },
    computed: {
        // 表示するテンプレートデータ
        template: function () {
            if (this.isInlineMode) {
                return this.inline_template;
            }
            return this.modal_template;
        },
        // インラインモードか否か
        isInlineMode: function () {
            return (this.mode === 'inline');
        },
    },
    mixins: [
        modalMixin,
    ],
    /**
     * コンポーネント群
     */
    components: {
        // プレビューの中身
        'preview-content': {
            name: 'previewContent',
            template: '#preview_content',
            props: {
                // 表示モード modal|inline
                mode: {
                    type: [String],
                    require: true
                },
                // 全データ
                template: {
                    type: Object,
                    default: () => ({}),
                    required: true
                }
            },
            components: {
                // 静的HTMLを表示するコンポーネント
                'show-static-html': showStaticHtml,
            },
        }
    },
    methods: {
        // プレビューを開く
        show: function (template) {
            this.modal_template = template;
            // 先にフラグを立ててタイムラグをなくす
            this.modal_opened = true;
            this.open();
        },
    }
};